(function() {
  function createEmoji(emoji, x, y, delay) {
    const el = document.createElement('div');
    el.className = 'emoji-burst';
    el.style.left = `${x}px`;
    el.style.top = `${y}px`;
    el.innerText = emoji;
    document.body.appendChild(el);

    // Use a small timeout to allow the browser to render the element before animating
    setTimeout(() => {
      el.animate([
        { transform: 'translate(-50%, -50%) scale(1) rotate(0deg)', opacity: 1 },
        { transform: `translate(${x - 50 + (Math.random() * 200 - 100)}px, ${y - 50 + (Math.random() * 200 - 100)}px) scale(0) rotate(360deg)`, opacity: 0 }
      ], {
        duration: 2000, // 2000ms = 2 seconds for a slower animation
        easing: 'ease-out'
      }).onfinish = () => el.remove();
    }, delay); // delay each emoji's animation slightly
  }

  function triggerEmojiBurst(event) {
    const emojis = ['💖', '💛', '✨', '🌸', '❤️', '🌟', '💫', '✨'];
    const burstCount = 40; // Increased number of emojis
    const rect = event.currentTarget.getBoundingClientRect();
    const x = rect.left + rect.width / 2;
    const y = rect.top + rect.height / 2;

    for (let i = 0; i < burstCount; i++) {
      const randomEmoji = emojis[Math.floor(Math.random() * emojis.length)];
      createEmoji(randomEmoji, x, y, i * 20); // Add a small delay for each emoji
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const addToCartButtons = document.querySelectorAll('.add-to-cart-btn, .push-btn');
    addToCartButtons.forEach(button => {
      button.addEventListener('click', triggerEmojiBurst);
    });
  });
})();